var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md:py-4 lg:py-4"},[_c('Create-Post-Sidebar'),_c('base-button',{staticClass:"flex w-full py-3",attrs:{"type":"primary"},on:{"click":_vm.createPost}},[_c('feather-icon',{staticClass:"mr-1",attrs:{"icon":"EditIcon"}}),_vm._v("Create Post\n  ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }